import type { IconSvgObject } from './types';

const AlignVerticalJustifyCenterIcon: IconSvgObject = [
  ["path", { d: "M16 16L8 16C6.89543 16 6 16.8954 6 18L6 19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V18C18 16.8954 17.1046 16 16 16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 3L10 3C8.89543 3 8 3.89543 8 5L8 6C8 7.10457 8.89543 8 10 8L14 8C15.1046 8 16 7.10457 16 6V5C16 3.89543 15.1046 3 14 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 12L3 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignVerticalJustifyCenterIcon;
